import { Typography } from "@/components";
import { BackAppBar } from "@/components/ui";
import { RequestAccessCaseSearchParamSchema } from "@/schemas";
import Button from "@mui/material/Button";
import { Link, createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";

export const Route = createFileRoute(
	"/dashboard/case/create/exist/request-complete",
)({
	validateSearch: zodSearchValidator(RequestAccessCaseSearchParamSchema),
	component: RouteComponent,
});

function RouteComponent() {
	const searchParams = Route.useSearch({
		select: (state) => state,
	});
	return (
		<>
			<BackAppBar />
			<div className="container h-full flex flex-col gap-8 bg-white">
				<Typography fontWeight={600} fontSize={28}>
					Request Sent!
				</Typography>
				<Typography fontWeight={400} fontSize={14}>
					HEMI Teams will alert you once the team responds to your access
					request.
				</Typography>
				<div className="flex flex-col gap-2">
					<Link
						to="/dashboard/case/$status"
						params={{ status: "active" }}
						replace
					>
						<Button
							fullWidth
							variant="contained"
							color="primary"
							size="large"
							className="!rounded-full"
						>
							Done
						</Button>
					</Link>
					<Link to="/dashboard/case/create" search={searchParams} replace>
						<Button
							fullWidth
							variant="outlined"
							color="primary"
							size="large"
							className="!rounded-full"
						>
							Add new Case
						</Button>
					</Link>
				</div>
			</div>
		</>
	);
}
